import { rem } from 'polished';

import { IconProps } from '@chakra-ui/react';
import VerifiedIcon from '@sphere/icons/components/Verified';

export const VerifiedBadge = ({ ...props }: IconProps) => (
  <VerifiedIcon
    data-testid="verified-badge"
    boxSize={rem(16)}
    sx={{
      color: '#0089EC',
      circle: {
        fill: 'white',
      },
    }}
    {...props}
  />
);
